import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { colors, duration, easing, spacing, WebLink2 } from 'ui/theme';
import { Popover, PopoverContent, PopoverPlacements, PopoverTrigger } from 'ui/popover';
import { selectIsContextualizedMetricsFeatureFlagOn } from 'core/userContext';

type MetricDefinitionPopOverProps = {
  definition?: string;
  learnMoreLink?: string;
  children: React.ReactNode;
};

const StyledPopoverContent = styled(PopoverContent)`
  width: ${spacing.x16};
  &:focus-visible {
    outline: none;
  }
`;

const StyledPopoverTrigger = styled(PopoverTrigger)`
  color: ${colors.textSecondary};
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: ${spacing.quarter};
  transition: all ${easing.standard} ${duration.short};
  &:focus-visible {
    outline: none;
  }
  :hover {
    transition: all ${easing.standard} ${duration.short};
    color: ${colors.textPrimary};
  }
`;

const LinkWrapper = styled.div`
  margin-top: ${spacing.half};
`;

export const MetricDefinitionPopOver = ({
  definition,
  learnMoreLink,
  children,
}: MetricDefinitionPopOverProps) => {
  const isContextualizedMetricsOn = useSelector(selectIsContextualizedMetricsFeatureFlagOn);

  if (!isContextualizedMetricsOn || !definition) {
    return <>{children}</>;
  } else {
    const content = (
      <>
        <div>{definition}</div>
        {learnMoreLink && (
          <LinkWrapper>
            <WebLink2 href={learnMoreLink} target="_blank">
              Learn More
            </WebLink2>
          </LinkWrapper>
        )}
      </>
    );

    return (
      <Popover>
        <StyledPopoverContent side={PopoverPlacements.Top}>{content}</StyledPopoverContent>
        <StyledPopoverTrigger data-test="metric-definiton-popover-trigger" asChild>
          {children}
        </StyledPopoverTrigger>
      </Popover>
    );
  }
};
